$( document ).ready(function() {
    // VARIABLES
    var windowWidth = $(window).outerWidth();
    var headerHeight = $('#header').outerHeight();
    var oldheaderPadding = $('.header-main-wrap').css('padding');

	// FUNCTIONS
	$('a[data-rel^=lightcase]').lightcase({ showSequenceInfo: false });

	// WINDOW ON LOAD
	$(window).on("load", function(){
		caroufredsel_slider();
    if(window.matchMedia('(min-width: 992px)').matches){
        stickSidebar(windowWidth);
    }
	  // LOADER
    $(window).resize();
    setTimeout(function(){
      $('.spinner-wrap').css({'opacity': '0'});
      $('.spinner-wrap').hide();
    },500);
	});

	// WINDOW ON RESIZE with Timer for better usage
	$(window).on('resize', function(e){
    	caroufredsel_slider();

      clearTimeout(window.resizedFinished);
      window.resizedFinished = setTimeout(function(){
          var windowWidth = $(window).outerWidth();

          // $('.contact-info').slideDown(300);
          // $('.header-main-wrap').css({'padding': oldheaderPadding, 'transition': '.3s'});

          if(window.matchMedia('(min-width: 992px)').matches){
              stickSidebar(windowWidth);
              $('#dismiss').click();
          }else{
              $('.sidebar').trigger('sticky_kit:detach');
          }

          setTimeout(function(){
              var headerHeight = $('#header').outerHeight();

          },600);

      }, 350);
  	});

  	// IOS INPUT BUG FIX
    (function iOS_CaretBug() {
       var ua = navigator.userAgent,
       scrollTopPosition,
       iOS = /iPad|iPhone|iPod/.test(ua),
       iOS11 = /OS 9|OS 10|OS 11_0|OS 11_1|OS 11_2/.test(ua);

       // ios 11 bug caret position
       if ( iOS && iOS11 ) {

           $(document.body).on('show.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Get scroll position before moving top
                   scrollTopPosition = $(document).scrollTop();

                   // Add CSS to body "position: fixed"
                   $("body").addClass("iosBugFixCaret");
               }
           });

           $(document.body).on('hide.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Remove CSS to body "position: fixed"
                   $("body").removeClass("iosBugFixCaret");

                   //Go back to initial position in document
                   $(document).scrollTop(scrollTopPosition);
               }
           });
       }
    })();

    // Mobile Sidebar
    $('.hamburger').on('click', function () {
      $(this).toggleClass("is-active");
      $('#sidemob').addClass('active');
      if($('#sidemob').hasClass('active')){
        $("body").css("overflow", "hidden");
      }else{
        $("body").css("overflow", "visible");
      }
      $('.sidemob-overlay').fadeIn(200);
      $('.collapse.in').toggleClass('in');
      // $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });
    $('#dismiss, .sidemob-overlay').on('click', function () {
      $('.hamburger').removeClass("is-active");
      $('#sidemob').removeClass('active');
      if($('#sidemob').hasClass('active')){
        $("body").css("overflow", "hidden");
      }else{
        $("body").css("overflow", "visible");
      }
      $('.sidemob-overlay').fadeOut(200);
    });
    $('.hamburger').on('click', function(){
      if(!$(this).hasClass('is-active'))
        $('#dismiss').click();
    });

    // Navigation Dropdown
    $('ul.nav-links li.dropdown').hover( function() {
        $(this).find('.dropdown-menu').eq(0).stop(true, true).delay(200).slideDown(200);
    }, function() {
        $(this).find('.dropdown-menu').eq(0).stop(true, true).delay(200).slideUp(200);
    });
    // Categories Dropdown
    $('ul.cat-links li.dropdown').hover( function() {
        $(this).find('.dropdown-menu').eq(0).stop(true, true).delay(200).slideDown(200);
    }, function() {
        $(this).find('.dropdown-menu').eq(0).stop(true, true).delay(200).slideUp(200);
    });

    // Serach Overlay
    $('.mobile-search').on('click', function(e){
      e.preventDefault();
      $('.search-overlay').slideDown('300');
    });
    $('.search-close, #content, #footer').on('click', function(){
      $('.search-overlay').slideUp('300');
    });

    // Owl carousel
    // Hero Slider
    var hero_slider = $('#hero .owl-carousel');
    var $hero_autoplay = hero_slider.data('autoplay');
    var $hero_timeout = parseInt(hero_slider.data('timeout'));
    var $hero_hover = hero_slider.data('hover');
    hero_slider.owlCarousel({
      animateOut:'fadeOut',
      autoplay:$hero_autoplay,
      autoplayTimeout:$hero_timeout,
      autoplayHoverPause:$hero_hover,
      autoplaySpeed:1000,
      dotsSpeed:1000,
      dragEndSpeed:1000,
      navSpeed:1000,
      responsiveClass:true,
      responsiveRefreshRate:500,
      nav:true,
      navText: ['<a href="javascript:void(0);" class="btn-prev" title="Previous Slide"><i class="fas fa-angle-left"></i></a>','<a href="javascript:void(0);" class="btn-next" title="Next Slide"><i class="fas fa-angle-right"></i></a>'],
      dots:false,
      dotsEach:false,
      slideTransition:'ease',
      responsive:{
          0:{ loop:$('#hero .owl-carousel .hero-slide').size() > 1 ? true:false,autoHeight:true,autoWidth:false,items:1,center:true,margin:200 }
      },
    });
    hero_slider.on('click', '.owl-nav button', function(e) {
        hero_slider.trigger('stop.owl.autoplay');
        hero_slider.trigger('play.owl.autoplay');
    });
    hero_slider.on('dragged.owl.carousel', function(e) {
        hero_slider.trigger('stop.owl.autoplay');
        hero_slider.trigger('play.owl.autoplay');
    });
    
    // Testimonial Slider
    var t_slider = $('#testimonials .owl-carousel');
    var $t_autoplay = t_slider.data('autoplay');
    var $t_timeout = parseInt(t_slider.data('timeout'));
    var $t_hover = t_slider.data('hover');
    t_slider.owlCarousel({
      // animateOut:'fadeOut',
      autoplay:$t_autoplay,
      autoplayTimeout:$t_timeout,
      autoplayHoverPause:$t_hover,
      autoplaySpeed:1000,
      dotsSpeed:1000,
      dragEndSpeed:1000,
      navSpeed:1000,
      responsiveClass:true,
      responsiveRefreshRate:50,
      nav:true,
      navText: ['<a href="javascript:void(0);" class="btn-prev" title="Previous Slide"><i class="fas fa-angle-left"></i></a>','<a href="javascript:void(0);" class="btn-next" title="Next Slide"><i class="fas fa-angle-right"></i></a>'],
      dots:false,
      // dotsEach:true,
      responsive:{
          0:{ loop:$('#testimonials .owl-carousel li').size() > 1 ? true:false,autoHeight:true,autoWidth:false,items:1,center:true,margin:0 },
          768:{ loop:$('#testimonials .owl-carousel li').size() > 1 ? true:false,autoHeight:true,autoWidth:true,items:1,center:true,margin:0 }
      },
      startPosition: 1
    });

    // Scroll to Top
    var pxScrolled = 200;
    var duration = 500;
    $(window).scroll(function() {

        // For BTT
        if ($(this).scrollTop() > pxScrolled) {
            $('.fab-container').css({'bottom': '0px', 'transition': '.3s'});
        } else {
            $('.fab').off('mouseenter mouseleave');
            $('.fab-container').css({'bottom': '-82px'});
        }

    });

    $('.goTop').on('click', function() {
        $('html, body').animate({scrollTop: '0px'}, duration);
        $('.fab').off('mouseenter mouseleave');
    })

    // CAROUFREDSEL SLIDER
    function caroufredsel_slider() {
      $(".cs-slider .slides").each(function(){
        var $this    = $(this);
        var ctrlPrev = $(this).closest(".cs-slider").find(".prev");
        var ctrlNext = $(this).closest(".cs-slider").find(".next");

        $this.carouFredSel({
          auto: {
            play: $this.data("auto"),
            timeoutDuration: $this.data("duration"),
          },
          start      : "random",
          width      : $this.data("cs-width"),
          circular   : $this.data("cs-circular"),
          infinite   : $this.data("cs-infinite"),
          height     : $this.data("cs-height"),
          responsive : $this.data("cs-responsive"),
          direction  : $this.data("cs-direction"),
          prev       : ctrlPrev,
          next       : ctrlNext,
          pagination : "."+$this.data("paginate"),
          scroll:{
            items: $this.data("item-scroll"),
            fx   : $this.data("effects"),
          },
          items:{
            height : $this.data("item-height"),
            width  : $this.data("item-width"),
            visible: {
                min: $this.data("min"),
                max: $this.data("max")
            },
          },
          swipe:true,
        });

        $this.touchwipe({
          wipeUp: function(e) {
            e.preventDefault();
          },
          wipeDown: function(e) {
            e.preventDefault();
          },
          wipeLeft: function(e) {
            $this.trigger("next", 1);
          },
          wipeRight: function(e) {
            $this.trigger("prev", 1);
          }
        });
      });
    }
  	function products_slider() {
  		$(".related-products .products-wrap .products").each(function(){
  			var $this    = $(this);
  			var ctrlPrev = $(this).closest(".products-wrap").find(".prev");
  			var ctrlNext = $(this).closest(".products-wrap").find(".next");

  			$this.carouFredSel({
  				auto: {
  					play: $this.data("auto"),
  					timeoutDuration: $this.data("duration"),
  				},
  				start      : "random",
  				width      : $this.data("cs-width"),
  				circular   : $this.data("cs-circular"),
  				infinite   : $this.data("cs-infinite"),
  				height     : $this.data("cs-height"),
  				responsive : $this.data("cs-responsive"),
  				direction  : $this.data("cs-direction"),
  				prev       : ctrlPrev,
  				next       : ctrlNext,
  				pagination : "."+$this.data("paginate"),
  				scroll:{
  					items: $this.data("item-scroll"),
  					fx   : $this.data("effects"),
  				},
  				items:{
  				  height : $this.data("item-height"),
  				  width  : $this.data("item-width"),
  				  visible: {
  				    	min: $this.data("min"),
  				    	max: $this.data("max")
  				  },
  				},
  				swipe:true,
  			});

  			$this.touchwipe({
  				wipeUp: function(e) {
  				 	e.preventDefault();
  				},
  				wipeDown: function(e) {
  				 	e.preventDefault();
  				},
  				wipeLeft: function(e) {
  				 	$this.trigger("next", 1);
  				},
  				wipeRight: function(e) {
  				 	$this.trigger("prev", 1);
  				}
  			});
  		});
  	}
    function services_slider() {
      $(".service-slider .slides").each(function(){
        var $this    = $(this);
        var ctrlPrev = $(this).closest(".service-slider").find(".prev");
        var ctrlNext = $(this).closest(".service-slider").find(".next");

        $this.carouFredSel({
          auto: {
            play: $this.data("auto"),
            timeoutDuration: $this.data("duration"),
          },
          start      : "random",
          width      : $this.data("cs-width"),
          circular   : $this.data("cs-circular"),
          infinite   : $this.data("cs-infinite"),
          height     : $this.data("cs-height"),
          responsive : $this.data("cs-responsive"),
          direction  : $this.data("cs-direction"),
          prev       : ctrlPrev,
          next       : ctrlNext,
          pagination : "."+$this.data("paginate"),
          scroll:{
            items: $this.data("item-scroll"),
            fx   : $this.data("effects"),
          },
          items:{
            height : $this.data("item-height"),
            width  : $this.data("item-width"),
            visible: {
                min: $this.data("min"),
                max: $this.data("max")
            },
          },
          swipe:true,
        });

        $this.touchwipe({
          wipeUp: function(e) {
            e.preventDefault();
          },
          wipeDown: function(e) {
            e.preventDefault();
          },
          wipeLeft: function(e) {
            $this.trigger("next", 1);
          },
          wipeRight: function(e) {
            $this.trigger("prev", 1);
          }
        });
      });
    }

    // Fix Image and Link Margin inside p
    $('#hero .hero-content p:has(a), #contact-info .heading-wrap p:has(a), #default-page .page-content p:has(img)').css('margin', '0');
    $('#contact-info .address-info p:has(a.link)').addClass('add-links-wrap');

    // Dont remove this, fix for naivigation
    $('.nav-links > li:has(span)').addClass('add-m-fix');

    if($('#map').length){
      google.maps.event.addDomListener(window, "load", initMap);
    }

    if($('.address-map').length){
      google.maps.event.addDomListener(window, "load", initAddress);
    }

    // Navpills
    // $('.nav-pills .nav-link').on('click', function(){
    //   var target = $(this).attr('href');
    //   var target_con = $('.tab-content .tab-pane');
    //   if(target_con.attr('id') == target){
    //     $('.tab-content .tab-pane[id^="'+target+'"]').slideDown(600);
    //   }else{
    //     $('.tab-content .tab-pane[id^="'+target+'"]').slideUp();
    //   }
    // });

});

function fixHeader(h){
    var headerHeight = $('#header').outerHeight();
    // $('#content').css({'margin-top': h - 2,'transition': 'all .5s ease'});
}

function stickSidebar(ww){
    // Get offset_top
    var $offset = 0;
    if(window.matchMedia('(min-width: 992px)').matches && window.matchMedia('(max-width: 1199px)').matches){
      $offset = 170;
    }else if(window.matchMedia('(min-width: 1200px)').matches){
      $offset = 180;
    }
    // Stick Sidebar
    $(".sidebar").stick_in_parent({ offset_top: $offset });
}

function initMap() {
    // Custom map style pink mode.
    // Default value for lat and lang are : -33.86898610271999 and 151.20943900000007
    // The above is for backup purposes only. Thank you.
    var $lat = parseFloat($('#map').data('lat'));
    var $lng = parseFloat($('#map').data('lng'));
    var map = new google.maps.Map(document.getElementById('map'), {
      center: {lat: $lat, lng: $lng},
      zoom: 16,
      // zoomControl: true, Will be enabled incase requested
    });

    var marker = new google.maps.Marker({
      position: {lat: $lat, lng: $lng},
      map: map,
      title: $('#map').data('title'),
      icon: $('#map').data('map-icon')
    });
}

function initAddress() {
    // Custom map style pink mode.
    // Default value for lat and lang are : -33.86898610271999 and 151.20943900000007
    // The above is for backup purposes only. Thank you.
    $('.address-map').each( function(){
      var $lat = parseFloat($(this).data('lat'));
      var $lng = parseFloat($(this).data('lng'));
      var map = new google.maps.Map($(this).get(0), {
        center: {lat: $lat, lng: $lng},
        zoom: 15
        // disableDefaultUI: true
      });

      var marker = new google.maps.Marker({
        position: {lat: $lat, lng: $lng},
        map: map,
        title: $(this).data('title'),
        icon: $(this).data('map-icon')
      });
    });
}